export class LazyLoadImg {
    constructor() {
        this.imgs = document.querySelectorAll('.item-img');
        this.imageDefaultSmall = 'https://cdn1.staticpanvel.com.br/produtos/15/default.jpg?ims=150x';
        this.imageDefaultLarge = 'https://cdn1.staticpanvel.com.br/produtos/15/default.jpg?ims=282x';
        this.init();
    }

    init() {
        if(this.imgs) {
            this.processImages();
            window.addEventListener('scroll', () => this.processImages());
        }
    }

    imgInViewPort(el) {
        const rect = el.getBoundingClientRect();

        return (
            rect.top >= 0
            && rect.left >= 0
            && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    processImages() {
        for (let i = 0; i < this.imgs.length; i++) {
            if (this.imgInViewPort(this.imgs[i])) this.loadImage(this.imgs[i]);
        }
    }

    loadImage(el) {
        try {
            const picture = el.querySelector('picture');
            let imgPicture = null;

            if (picture) imgPicture = picture.querySelector('.item-img--small');
            else imgPicture = el.querySelector('.item-img--small');

            const imgLazy = el.querySelector('.item-img--lazy');

            if(imgPicture && !imgPicture.classList.contains('item-img--loaded')) {
                const imgLarge = new Image();
                const isIE = this.detectIEEdge();

                if (isIE === false) {
                  // img.currentSrc pega o melhor tamanho de img em termos de tamanho vs performace/SEO com picture > source tags (img.tag)
                  if (imgPicture.currentSrc) {
                    imgLarge.src = imgPicture.currentSrc;
                  } else {
                    // Pega o maior tamanho recebido pra corrigir o bug quando o <picure> e <source> não conseguem definir um currentSrc pra <img>
                    let fixCurrentSrc = imgPicture.getAttribute("fix-current-src");
                    imgLarge.src = fixCurrentSrc ? fixCurrentSrc : imgPicture.src;
                  }
                } else {
                  let fixCurrentSrc = imgPicture.getAttribute("fix-current-src");
                  imgLarge.src = fixCurrentSrc ? fixCurrentSrc : imgPicture.src;
                }

                imgLarge.title = imgPicture.title;
                imgLarge.alt = imgPicture.alt;
                imgLarge.onload = () => {
                  imgLarge.classList.add('item-img--loaded');
                  imgPicture.classList.add('item-img--loaded');
                  if (imgLazy) imgLazy.classList.remove('item-img--loaded');
                }
                imgLarge.onerror = () => {
                  imgLarge.src = this.imageDefaultLarge;
                }

                el.appendChild(imgLarge);
            }
        } catch (e) {
            console.log(e);
        }
    }

    detectIEEdge() {
        try {
            const ua = window.navigator.userAgent;

            const msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            const trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                const rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            const edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        } catch (e) {
            console.log('detectIEEdge Exception', e);
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/lazyLoadImg.js